'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	Vue.component('word-edit', {
		props: ['word', 'removeWord', 'initData'],
		data: function () {
			return {
				
			};
		},
		computed: {
			wordComponent: function () {
				return 'word-' + this.word.mode + '-edit';
			}
		},
		mounted: function () {

		},
		template:
			'<div class="word-edit">' +
				'<div class="row">' +
					'<div class="col-xs-12">' +
						'<button v-on:click="removeWord(word)" class="btn btn-xs btn-danger">{{initData.translations.remove}}</button>' +
						'<div class="form-group">' +
							'<label>{{initData.translations.word}}</label>' +
							'<input type="text" v-model="word.word" class="form-control" />' +
							'<small>{{initData.translations.wordEditorHelp}}</small>' +
						'</div>' +
						'<div class="form-group">' +
							'<label>{{initData.translations.wordMode}}</label>' +
							'<select v-model="word.mode" class="form-control">' +
								'<option value="random">{{initData.translations.randomType}}</option>' +
								'<option value="defined">{{initData.translations.definedType}}</option>' +
							'</select>' +
							'<small>{{initData.translations.modeEditorHelp}}</small>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div class="row">' +
					'<div class="col-xs-12">' +
						'<div :is="wordComponent" :word="word" :init-data="initData"></div>' +
					'</div>' +
				'</div>' +
			'</div>',
	});
});
